// extracted by mini-css-extract-plugin
module.exports = {"vanlife-roadtrips-G":"G2_vanlife-roadtrips-G__fAWb3"};